/* raw layout hash: _inspection-checklists-task-template-builder-layout:0213731af9589a6b894c8cb325ce4c95967a1ff09fc4a4762cc12bea4bf50973 */
import React from 'react';
import AppShell from './AppShell.jsx';
import { LAYOUT_MENUS } from './layoutMenus.js';

// Layout "_inspection-checklists-task-template-builder-layout" — renders its page content through the router outlet.
export default function InspectionChecklistsTaskTemplateBuilderLayout() {
  return <AppShell layoutName="_inspection-checklists-task-template-builder-layout" menu={LAYOUT_MENUS['_inspection-checklists-task-template-builder-layout']} />;
}
